import { ArrowRight } from 'lucide-react';

export function PaginationFooter({
  visibleCount,
  canLoadMore,
  isLoadingMore,
  onLoadMore,
}: {
  visibleCount: number;
  canLoadMore: boolean;
  isLoadingMore: boolean;
  onLoadMore: () => void;
}) {
  if (visibleCount === 0 && !canLoadMore) return null;
  return (
    <div className="flex items-center justify-between gap-3 border-t border-dark/10 px-6 py-3">
      <span className="text-xs text-muted-foreground">
        Showing <span className="font-bold text-dark">{visibleCount}</span>{' '}
        {visibleCount === 1 ? 'contact' : 'contacts'}
      </span>
      {canLoadMore && (
        <button
          type="button"
          onClick={onLoadMore}
          disabled={isLoadingMore}
          className="inline-flex items-center gap-1 text-xs font-bold text-info hover:underline disabled:opacity-50"
        >
          {isLoadingMore ? 'Loading…' : 'Load more'}
          {!isLoadingMore && <ArrowRight className="h-3.5 w-3.5" />}
        </button>
      )}
    </div>
  );
}
